export default __webpack_public_path__ + "static/media/flag-ja-JP.b9eade6b.png";